import stageHistoryIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/stageHistoryIcon.png'
import documentsCenterIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/documentsCenterIcon.png'
import resourceCenterIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/resourceCenterIcon.png'
import qaIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/q&aIcon.png'
import contactUsIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/contactUsIcon.png'
import referAFriendIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/referAFriendIcon.png'
import calenderIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/calenderIcon.png'
import discountIcon from '../../assets/DashboardIcons/DashboardSidePanelIcons/discountIcon.png'

export default function DashboardHeader({ activeTab }) {
  return (
    <div className='lg:w-full w-11/12 flex items-center justify-center h-20 bg-white rounded-md shadow-full mt-10 gap-4'>
      {activeTab === 0 ? (
        <>
          <img className='h-1/2' src={stageHistoryIcon} alt='stageHistoryIcon' />
          <p className='font-bold text-2xl'>Stage History</p>
        </>
      ) : activeTab === 1 ? (
        <>
          <img className='h-1/2' src={documentsCenterIcon} alt='documentsCenterIcon' />
          <p className='font-bold text-2xl'>Document Center</p>
        </>
      ) : activeTab === 2 ? (
        <>
          <img className='h-1/2' src={resourceCenterIcon} alt='resourceCenterIcon' />
          <p className='font-bold text-2xl'>Resource Center</p>
        </>
      ) : activeTab === 3 ? (
        <>
          <img className='h-1/2' src={qaIcon} alt='qaIcon' />
          <p className='font-bold text-2xl'>Q&A</p>
        </>
      ) : activeTab === 4 ? (
        <>
          <img className='h-1/2' src={contactUsIcon} alt='qaIcon' />
          <p className='font-bold text-2xl'>Contact Us</p>
        </>
      ) : activeTab === 5 ? (
        <>
          <img className='h-1/2' src={referAFriendIcon} alt='qaIcon' />
          <p className='font-bold text-2xl'>Friend Referral Program</p>
        </>
      ) : activeTab === 6 ? (
        <>
          <img className='h-1/2' src={calenderIcon} alt='qaIcon' />
          <p className='font-bold text-2xl'>Change Days</p>
        </>
      ) : (
        <>
          <img className='h-1/2' src={discountIcon} alt='qaIcon' />
          <p className='font-bold text-2xl'>Discount Code</p>
        </>
      )}
    </div>
  )
}